import { styled } from 'styled-components'
import { onMediumScreen } from 'mixtiles-web-common'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.grayBackgroundWhite};
  height: 100%;

  ${onMediumScreen()} {
    width: 500px;
  }
`

export const Content = styled.div`
  padding: 25px;
  flex-grow: 1;
  overflow-y: auto;

  ${onMediumScreen()} {
    padding-bottom: 7px;
    max-height: 600px;
  }
`

export const IsSameAddressContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 15px;
  line-height: 17px;
  color: ${({ theme }) => theme.colors.black};
  margin: 20px 0;
`

export const IsSameAddressText = styled.div`
  margin-left: 7px;
`

export const Divider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.colors.grayMedium};
  margin: 20px 0;
`

export const BillingAddressHeader = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 16px;
`

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding-bottom: 10px;
`
